import React, {
    forwardRef,
    useImperativeHandle,
    useState
} from "react";

const TestComponent = forwardRef(function TestComponent(props, ref) {


    const sayHello = (msg = "", callback = () => {}) => {
        const ret = msg + " run on child component";
        alert(ret)
        callback(ret + " returned...");
    };

    useImperativeHandle(ref, () => ({
        sayHello
    }));

    return <div>Test</div>;
});

export default TestComponent;
